module.exports = "<settings-screen>\n  <div class=\"row\">\n    <div class=\"col-md-8\">\n      <dynamic-form target=\"dataSource\" type=\"data_sources\" actions=\"actions\">\n      </dynamic-form>\n    </div>\n  </div>\n</settings-screen>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/pages/data-sources/show.html
// module id = 770
// module chunks = 1